import React from "react";
import { Grid } from "@material-ui/core";
import ICommonFormProps from "../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";
import FormSelect from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormSelect";
import FormAlongsideText from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormAlongsideText";
import { useWatch } from "react-hook-form";


/**Switch component with helper text alongside */
const FormSelectWithText = (props: ICommonFormProps) => {
  const { control } = props;
  const enabled = useWatch({ control, name: "tipping_enabled" });
  if (!enabled) {
    return null;
  }
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      spacing={0}
      className={props.className}
    >
      <Grid item xs={4}>
        <FormSelect {...props} label=''/>
      </Grid>
      <Grid
          item
          xs={8}
          style={{ display: "flex", justifyContent: "flex-start" }}
        >
          <FormAlongsideText
            label={props.label}
            secondLabel={props.formProps?.secondLabel}
          />
        </Grid>
    </Grid>
  );
};

export default FormSelectWithText;
